export default __webpack_public_path__ + "static/media/SFProDisplay-Semibold.340c3a1a.woff";